import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyA2ql07qEjNbILmsiabYmCk3e57Ut_AaGA",
    authDomain: "photoapp-7eb39.firebaseapp.com",
    databaseURL: "https://photoapp-7eb39-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "photoapp-7eb39",
    storageBucket: "photoapp-7eb39.appspot.com",
    messagingSenderId: "467934327708",
    appId: "1:467934327708:web:96874b09cb7d2460f88e59"
};
firebase.initializeApp(firebaseConfig);

export const db = firebase.firestore()
export const auth = firebase.auth()
export const storage = firebase.storage();

export default firebase
